import { render, staticRenderFns } from "./edit-cognitive-test.vue?vue&type=template&id=e0b371fa&scoped=true&"
import script from "./edit-cognitive-test.vue?vue&type=script&lang=js&"
export * from "./edit-cognitive-test.vue?vue&type=script&lang=js&"
import style0 from "./edit-cognitive-test.vue?vue&type=style&index=0&id=e0b371fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b371fa",
  null
  
)

export default component.exports